import * as React from "react";
import styled from "styled-components";
import { OneNumberScoreData } from "../../../../../../../../server/models/graph/demand-forecast";
import { ReportTitle } from "../../../parts/report-title";
import { OneNumberScoreDetailGraph } from "../../../exective-report/one-number-score-detail/one-number-score-detail-graph";

export const Table = styled.table`
	margin-inline: auto;
`;
export const TitleBox = styled.div`
	font-size: 0.9em;
	border: 1px solid #aaa;
	display: flex;
	align-items: center;
	width: 90px;
	height: 90px;
	padding: 5px;
	text-align: center;
	div {
		text-align: center;
		width: 100%;
	}
`;

export type OneNumberScoreProps = {
	oneNumberScores: OneNumberScoreData[];
};
const max = 75;
export const OneNumberScoreDetail = React.memo((props: OneNumberScoreProps) => {
	const { oneNumberScores } = props;
	return (
		<>
			<ReportTitle>購入意向　ワンナンバースコア　結果詳細</ReportTitle>
			<Table>
				<tbody>
					<tr>
						<td>
							<TitleBox>
								<div>
									当該カテゴリ
									<br />
									ブランド
									<br />
									ユーザー
								</div>
							</TitleBox>
						</td>
						<td>
							<OneNumberScoreDetailGraph data={oneNumberScores} max={max} />
						</td>
					</tr>
				</tbody>
			</Table>
		</>
	);
});
